import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CePillComponent } from '@kempower-nx-workspace/shared/kp-design-system';
import { RouterModule } from '@angular/router';
import { BasicHeaderLayoutComponent } from '@kempower-nx-workspace/layout-templates';

@Component({
    selector: 'ce-core-header',
    imports: [CommonModule, BasicHeaderLayoutComponent, CePillComponent, RouterModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {}
